import { render, staticRenderFns } from "./StateProductBlock.vue?vue&type=template&id=28dd0fa4&scoped=true&"
import script from "./StateProductBlock.vue?vue&type=script&lang=js&"
export * from "./StateProductBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd0fa4",
  null
  
)

export default component.exports